"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROIVariableInput = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var ROICalculatorVariableInputField_1 = require("ContentTokens/SharedWidgetComponents/ROICalculator/ROICalculatorVariableInputField");
var ROITextInput_1 = require("ContentTokens/SharedWidgetComponents/ROICalculator/ROITextInput");
var react_1 = __importDefault(require("react"));
var UseHistoryTypes_1 = require("DataStores/User/UseHistory/UseHistoryTypes");
var ROIStep_1 = require("../ROISteps/ROIStep");
var ROIVariableInput = (function (_super) {
    __extends(ROIVariableInput, _super);
    function ROIVariableInput() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.handleTextChange = function (inputName, value) {
            _this.props.onChange(inputName, value);
        };
        _this.handleNumericalChange = function (inputName, value) {
            if (!value) {
                _this.props.onChange(inputName, 0);
            }
            var decimalPattern = /^\d*\.\d*$/g;
            if (decimalPattern.test(value)) {
                var _a = __read(value.split("."), 2), _ = _a[0], decimalPlaces = _a[1];
                _this.props.onChange(inputName, parseFloat(value).toFixed(decimalPlaces.length));
            }
            else {
                _this.props.onChange(inputName, parseFloat(value));
            }
        };
        _this.renderInputOptions = function () {
            var _a = _this.props, label = _a.label, min = _a.min, max = _a.max, prefix = _a.prefix, suffix = _a.suffix, onDelete = _a.onDelete, onOptionEdit = _a.onOptionEdit;
            return (react_1.default.createElement("div", { className: "roi-calculator-options__inner" },
                react_1.default.createElement("div", { className: "roi-calculator-options__heading" }, "Variable Options"),
                react_1.default.createElement(ROITextInput_1.ROITextInput, { inputName: "label", label: "Label", value: label, onChange: _this.handleTextChange, onValueEdited: onOptionEdit }),
                react_1.default.createElement("div", { className: "roi-calculator-options__dual" },
                    react_1.default.createElement(ROITextInput_1.ROITextInput, { inputName: "min", label: "Min", value: "".concat(min), onChange: _this.handleNumericalChange, onValueEdited: onOptionEdit, type: kaleidoscope_1.TextInputType.Number }),
                    react_1.default.createElement(ROITextInput_1.ROITextInput, { inputName: "max", label: "Max", value: "".concat(max), onChange: _this.handleNumericalChange, onValueEdited: onOptionEdit, type: kaleidoscope_1.TextInputType.Number })),
                react_1.default.createElement("div", { className: "roi-calculator-options__dual" },
                    react_1.default.createElement(ROITextInput_1.ROITextInput, { inputName: "prefix", label: "Prefix", value: prefix, onChange: _this.handleTextChange, onValueEdited: onOptionEdit }),
                    react_1.default.createElement(ROITextInput_1.ROITextInput, { inputName: "suffix", label: "Suffix", value: suffix, onChange: _this.handleTextChange, onValueEdited: onOptionEdit })),
                react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, isDestructive: true, "aria-label": "Delete input", width: "full", onClick: onDelete },
                    react_1.default.createElement(icons_1.Delete, null),
                    " Delete variable")));
        };
        return _this;
    }
    ROIVariableInput.prototype.render = function () {
        var _a = this.props, prefix = _a.prefix, suffix = _a.suffix, min = _a.min, max = _a.max, index = _a.index, roiStepsOrchestrator = _a.roiStepsOrchestrator;
        var maybeWrapWithROIStep = function (children) {
            return index === 0 ? react_1.default.createElement(ROIStep_1.ROIStep, { id: UseHistoryTypes_1.ROIStepId.AddEditVariables }, children) : children;
        };
        var labelWithId = "(".concat(this.props.id, ") ").concat(this.props.label);
        return (react_1.default.createElement("div", { className: "roi-calculator-panel-contents__variable-input space-stack-m" },
            react_1.default.createElement(ROICalculatorVariableInputField_1.ROICalculatorVariableInputField, { label: labelWithId, onChange: this.handleNumericalChange, value: "".concat(this.props.value), min: min, max: max, prefix: prefix, suffix: suffix, onValueEdited: this.props.trackValueChange }),
            react_1.default.createElement(kaleidoscope_1.Popover, { autoStack: true, position: kaleidoscope_1.PopoverPosition.Top, className: "roi-calculator-options", button: function (buttonProps) { return (react_1.default.createElement("div", { className: "roi-calculator-options__button" }, maybeWrapWithROIStep(react_1.default.createElement(kaleidoscope_1.IconButton, __assign({ icon: react_1.default.createElement(icons_1.Edit, null), "aria-label": "Edit" }, buttonProps, { tooltip: {
                        content: "Variable options",
                        show: roiStepsOrchestrator.shouldShowStep(UseHistoryTypes_1.ROIStepId.AddEditVariables) ? false : undefined,
                    }, onClick: function (e) {
                        roiStepsOrchestrator.completeStep(UseHistoryTypes_1.ROIStepId.AddEditVariables);
                        buttonProps.onClick(e);
                    } }))))); } }, this.renderInputOptions())));
    };
    return ROIVariableInput;
}(react_1.default.Component));
exports.ROIVariableInput = ROIVariableInput;
